import { wrapMeshInGroup } from "../../helpers/wrapMeshInGroup";
import { elementMappings } from "./config";

export const loadElementiForTables = async (glbName, glb) => {
    const mappings = elementMappings[glbName];
    if (!mappings) {
        console.warn(`[loadElementiForTables] Нет маппингов для ${glbName}`);
        return;
    }

    const children = [...glb.children]; // Создаем копию массива для безопасной итерации

    for (const el of children) {
        // Используем for...of для итерации по копии
        for (const mapping of mappings) {
            const { key, allArray, activeArray, position, extra } = mapping;

            if (el.name.includes(key)) {
                let target = el;

                if (el.isMesh) {
                    target = wrapMeshInGroup(el);
                    // Важно: если вы обернули Mesh в Group, замените Mesh на Group в родительском объекте GLB
                    glb.remove(el);
                    glb.add(target);
                }

                if (allArray) {
                    // Если такого массива не существует - создадим его, чтобы избежать ошибок
                    const targetAllArray = servObj[allArray];
                    if (!targetAllArray) {
                        servObj[allArray] = [];
                    }

                    servObj[allArray].push(target);
                    target.userData.allFolderName = allArray;
                }
                if (activeArray) {
                    // Если такого массива не существует - создадим его, чтобы избежать ошибок
                    const targetActiveArray = servObj[activeArray];
                    if (!targetActiveArray) {
                        servObj[activeArray] = [];
                    }

                    target.userData.activeFolderName = activeArray;
                }
                if (position) {
                    target.userData.position = position;
                    target.userData.isBottom = position === "bottom";
                }
                if (extra) extra.call(mapping, target);

                target.userData.glbName = glbName;
            }
        }
    }
};
